// Translations for Yetkin Dienstleistungen website

export const translations = {
  // Navigation
  nav: {
    about: { de: 'Über uns', en: 'About Us' },
    services: { de: 'Dienstleistungen', en: 'Services' },
    news: { de: 'Nachricht', en: 'News' },
    partners: { de: 'Partner & Sponsoren', en: 'Partners & Sponsors' },
    careers: { de: 'Karriere', en: 'Careers' },
    contact: { de: 'Kontakt', en: 'Contact' }
  },

  // Hero Section
  hero: {
    tagline: { de: 'Exzellenz in Hospitality', en: 'Excellence in Hospitality' },
    headline: { de: 'Zuverlässige Gastgewerbe', en: 'Reliable Hospitality' },
    subheadline: { de: 'Personal-Lösungen', en: 'Staffing Solutions' },
    description: { de: 'Gastgewerbebetriebe mit qualifizierten Fachkräften stärken', en: 'Empowering hospitality businesses with qualified professionals' },
    ctaText: { de: 'Personal jetzt anfordern', en: 'Request Staff Now' }
  },

  // Services
  services: {
    title: { de: 'Unsere Dienstleistungen', en: 'Our Services' },
    subtitle: { de: 'Professionelle Hospitality-Lösungen für Ihr Unternehmen', en: 'Professional hospitality solutions for your business' },
    housekeeping: {
      title: { de: 'Housekeeping Services', en: 'Housekeeping Services' },
      subtitle: { de: 'Makellose Sauberkeit', en: 'Impeccable Cleanliness' },
      description: { 
        de: 'Verlassen Sie sich auf Profis. Wir bieten geschultes Reinigungspersonal und Supervisoren, die Sauberkeit zur Priorität machen. Schaffen Sie eine sichere Wohlfühl-Atmosphäre, die Ihre Gäste lieben werden.',
        en: 'Rely on professionals. We provide trained cleaning staff and supervisors who make cleanliness a priority. Create a safe, comfortable atmosphere that your guests will love.'
      }
    },
    frontOffice: {
      title: { de: 'Front Office, Concierge und Bell Staff Services', en: 'Front Office, Concierge and Bell Staff Services' },
      subtitle: { de: 'Erster Eindruck zählt', en: 'First Impressions Matter' },
      description: {
        de: 'Unser Front Office-Team ist das Gesicht Ihres Hotels. Wir garantieren herzliche Begrüßungen, reibungslose Check-ins und mehrsprachigen Service. Für einen Empfang, der Ihren Gästen im Gedächtnis bleibt.',
        en: 'Our front office team is the face of your hotel. We guarantee warm welcomes, smooth check-ins, and multilingual service. For a reception your guests will remember.'
      }
    },
    windowCleaning: {
      title: { de: 'Fensterreinigungsdienste', en: 'Window Cleaning Services' },
      subtitle: { de: 'Kristallklare Sicht', en: 'Crystal Clear View' },
      description: {
        de: 'Ob Lobbyfassade oder Gästezimmer: Unser spezialisiertes Team sorgt für streifenfreien Glanz im Innen- und Außenbereich. Wir garantieren kristallklare Fenster und ein strahlendes Erscheinungsbild.',
        en: 'Whether lobby facade or guest room: Our specialized team ensures streak-free shine indoors and outdoors. We guarantee crystal-clear windows and a radiant appearance.'
      }
    },
    kitchen: {
      title: { de: 'Küchen-, Stewarding- und Bankett-Services', en: 'Kitchen, Stewarding and Banquet Services' },
      subtitle: { de: 'Kulinarische Exzellenz', en: 'Culinary Excellence' },
      description: {
        de: 'Von der Vorbereitung bis zum Servieren: Wir stellen erstklassige Teams für Küche, Stewarding und Bankett. Mit Fachwissen und Leidenschaft sorgen wir für ein nahtloses Speiseerlebnis und höchste Lebensmittelsicherheit in Ihrem Betrieb.',
        en: 'From preparation to serving: We provide first-class teams for kitchen, stewarding, and banquet. With expertise and passion, we ensure a seamless dining experience and highest food safety in your establishment.'
      }
    }
  },

  // Benefits
  benefits: {
    title: { de: 'Warum Yetkin?', en: 'Why Yetkin?' },
    professional: {
      title: { de: 'Professionelles Personal', en: 'Professional Staff' },
      description: { de: 'Qualifizierte und erfahrene Fachkräfte', en: 'Qualified and experienced professionals' }
    },
    reliable: {
      title: { de: 'Zuverlässiger Service', en: 'Reliable Service' },
      description: { de: 'Pünktlich und verlässlich rund um die Uhr', en: 'Punctual and reliable around the clock' }
    },
    satisfaction: {
      title: { de: 'Gäste Zufriedenheit', en: 'Guest Satisfaction' },
      description: { de: 'Höchste Standards für Ihre Gäste', en: 'Highest standards for your guests' }
    },
    flexible: {
      title: { de: 'Flexible Lösungen', en: 'Flexible Solutions' },
      description: { de: 'Angepasst an Ihre Bedürfnisse', en: 'Adapted to your needs' }
    }
  },

  // About Page
  about: {
    title: { de: 'Über uns', en: 'About Us' },
    subtitle: { de: 'Lernen Sie unser Team kennen', en: 'Meet Our Team' },
    ceoRole: { de: 'Geschäftsführer', en: 'CEO' },
    bio1: {
      de: 'Ausgebildet in der 5-Sterne-Hotellerie, erkannte ich schnell meine Leidenschaft für den Beruf des Hotel-Concierge. Nach meiner Ausbildung folgte ich dem klassischen Weg vom Pagen zum Concierge, bis ich mich schließlich selbstständig machte und seit 2018 mit meinem Team aus erfahrenen Hotel-Concierges mehrere Hotels in Berlin unterstütze.',
      en: 'Trained in 5-star hospitality, I quickly recognized my passion for the hotel concierge profession. After my training, I followed the classic path from page to concierge, until I finally became self-employed and since 2018 have been supporting several hotels in Berlin with my team of experienced hotel concierges.'
    },
    bio2: {
      de: 'Geprägt von den Schwierigkeiten der Pandemie, formte sich in mir die Idee der Veränderung, und so fand ich einen Weg, das Geschäft zu erweitern. Seit 2021 unterstütze ich mehrere Hotels in Berlin und Brandenburg im Bereich Housekeeping.',
      en: 'Shaped by the difficulties of the pandemic, the idea of change formed in me, and so I found a way to expand the business. Since 2021, I have been supporting several hotels in Berlin and Brandenburg in the housekeeping sector.'
    },
    bio3: {
      de: 'Für mich ist exzellenter Service genauso wichtig wie Sauberkeit und Hygiene im Unternehmen. Ich bin täglich persönlich im Einsatz, um Sie in diesen Bereichen zu unterstützen und stehe im Notfall fast rund um die Uhr zur Verfügung, um jederzeit reagieren zu können.',
      en: 'For me, excellent service is just as important as cleanliness and hygiene in the company. I am personally on duty every day to support you in these areas and am available almost around the clock in emergencies to respond at any time.'
    },
    values: { de: 'Unsere Werte', en: 'Our Values' },
    excellence: { de: 'Exzellenz', en: 'Excellence' },
    excellenceDesc: { de: 'Wir streben nach höchsten Standards in allem, was wir tun.', en: 'We strive for the highest standards in everything we do.' },
    reliability: { de: 'Zuverlässigkeit', en: 'Reliability' },
    reliabilityDesc: { de: 'Sie können sich auf uns verlassen - rund um die Uhr.', en: 'You can count on us - around the clock.' },
    partnership: { de: 'Partnerschaft', en: 'Partnership' },
    partnershipDesc: { de: 'Gemeinsam mit unseren Kunden zum Erfolg.', en: 'Together with our customers to success.' }
  },

  // Contact Page
  contact: {
    title: { de: 'Kontakt', en: 'Contact' },
    subtitle: { de: 'Haben Sie eine Frage oder möchten Sie mit uns zusammenarbeiten? Senden Sie uns eine Nachricht und wir melden uns bald bei Ihnen.', en: 'Have a question or want to work with us? Send us a message and we will get back to you soon.' },
    firstName: { de: 'Vorname', en: 'First Name' },
    lastName: { de: 'Nachname', en: 'Last Name' },
    email: { de: 'E-Mail', en: 'Email' },
    subject: { de: 'Betreff', en: 'Subject' },
    message: { de: 'Nachricht', en: 'Message' },
    send: { de: 'Nachricht senden', en: 'Send Message' },
    sending: { de: 'Wird gesendet...', en: 'Sending...' },
    success: { de: 'Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.', en: 'Thank you! Your message has been sent successfully.' },
    error: { de: 'Fehler beim Senden. Bitte versuchen Sie es erneut.', en: 'Error sending. Please try again.' }
  },

  // Partners Page
  partners: {
    title: { de: 'Partner & Sponsoren', en: 'Partners & Sponsors' },
    subtitle: { de: 'Wir arbeiten mit führenden Unternehmen der Hospitality-Branche zusammen', en: 'We work with leading companies in the hospitality industry' },
    hotelPartners: { de: 'Hotel Partner', en: 'Hotel Partners' },
    sponsor: { de: 'Unser Sponsor', en: 'Our Sponsor' },
    sponsorDesc: { de: 'Unterstützung des professionellen Basketballs in Berlin mit unserem Engagement für Exzellenz in Hospitality-Dienstleistungen.', en: 'Supporting professional basketball in Berlin with our commitment to excellence in hospitality services.' }
  },

  // Careers Page
  careers: {
    title: { de: 'Karriere', en: 'Careers' },
    subtitle: { de: 'Werden Sie Teil unseres Teams', en: 'Join Our Team' },
    joinUs: { de: 'Jetzt bewerben', en: 'Apply Now' },
    benefits: { de: 'Was wir bieten', en: 'What We Offer' },
    growth: { de: 'Karrierechancen', en: 'Career Opportunities' },
    growthDesc: { de: 'Entwickeln Sie sich mit uns weiter', en: 'Grow with us' },
    training: { de: 'Weiterbildung', en: 'Training' },
    trainingDesc: { de: 'Regelmäßige Schulungen und Fortbildungen', en: 'Regular training and continuing education' },
    team: { de: 'Teamkultur', en: 'Team Culture' },
    teamDesc: { de: 'Arbeiten Sie in einem motivierten Team', en: 'Work in a motivated team' }
  },

  // News Page
  news: {
    title: { de: 'Nachricht', en: 'News' },
    subtitle: { de: 'Neuigkeiten aus unserem Unternehmen', en: 'News from our company' },
    readMore: { de: 'Mehr lesen', en: 'Read More' }
  },

  // Footer
  footer: {
    tagline: { de: 'Exzellenz in Hospitality-Dienstleistungen', en: 'Excellence in Hospitality Services' },
    navigation: { de: 'Navigation', en: 'Navigation' },
    servicesTitle: { de: 'Dienstleistungen', en: 'Services' },
    contactTitle: { de: 'Kontakt', en: 'Contact' },
    copyright: { de: '© 2025 Yetkin Dienstleistungen. Alle Rechte vorbehalten.', en: '© 2025 Yetkin Dienstleistungen. All rights reserved.' },
    privacyPolicy: { de: 'Datenschutz', en: 'Privacy Policy' },
    legalNotice: { de: 'Impressum', en: 'Legal Notice' }
  },

  // Cookie Consent
  cookie: {
    title: { de: 'Cookie-Einstellungen', en: 'Cookie Settings' },
    message: { 
      de: 'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Sie können wählen, welche Cookies Sie akzeptieren möchten.',
      en: 'We use cookies to improve your experience on our website. You can choose which cookies you want to accept.'
    },
    acceptAll: { de: 'Alle akzeptieren', en: 'Accept All' },
    essentialOnly: { de: 'Nur notwendige', en: 'Essential Only' },
    moreInfo: { de: 'Mehr erfahren', en: 'Learn More' }
  },

  // Common
  common: {
    learnMore: { de: 'Mehr erfahren', en: 'Learn More' },
    contactUs: { de: 'Kontaktieren Sie uns', en: 'Contact Us' },
    back: { de: 'Zurück', en: 'Back' },
    close: { de: 'Schließen', en: 'Close' }
  }
};

// SEO Meta data for each page
export const seoData = {
  home: {
    title: { 
      de: 'Yetkin Dienstleistungen | Professionelle Hospitality-Lösungen in Berlin',
      en: 'Yetkin Dienstleistungen | Professional Hospitality Solutions in Berlin'
    },
    description: {
      de: 'Yetkin Dienstleistungen bietet professionelles Housekeeping, Front Office, Fensterreinigung und Küchen-Services für Hotels in Berlin und Brandenburg. Zuverlässiges Personal für Ihre Hospitality-Bedürfnisse.',
      en: 'Yetkin Dienstleistungen offers professional housekeeping, front office, window cleaning, and kitchen services for hotels in Berlin and Brandenburg. Reliable staff for your hospitality needs.'
    }
  },
  about: {
    title: {
      de: 'Über uns | Yetkin Dienstleistungen',
      en: 'About Us | Yetkin Dienstleistungen'
    },
    description: {
      de: 'Lernen Sie Yetkin Dienstleistungen kennen - seit 2018 unterstützen wir Hotels in Berlin mit professionellem Personal. Gegründet von Cagdas Yetkin mit 5-Sterne-Hotellerie-Erfahrung.',
      en: 'Get to know Yetkin Dienstleistungen - since 2018 we have been supporting hotels in Berlin with professional staff. Founded by Cagdas Yetkin with 5-star hospitality experience.'
    }
  },
  services: {
    title: {
      de: 'Unsere Dienstleistungen | Yetkin Dienstleistungen',
      en: 'Our Services | Yetkin Dienstleistungen'
    },
    description: {
      de: 'Entdecken Sie unsere Hospitality-Dienstleistungen: Housekeeping, Front Office, Concierge, Fensterreinigung, Küche und Bankett-Services für Hotels in Berlin.',
      en: 'Discover our hospitality services: housekeeping, front office, concierge, window cleaning, kitchen and banquet services for hotels in Berlin.'
    }
  },
  contact: {
    title: {
      de: 'Kontakt | Yetkin Dienstleistungen',
      en: 'Contact | Yetkin Dienstleistungen'
    },
    description: {
      de: 'Kontaktieren Sie Yetkin Dienstleistungen für professionelle Hospitality-Lösungen. Wir freuen uns auf Ihre Anfrage.',
      en: 'Contact Yetkin Dienstleistungen for professional hospitality solutions. We look forward to your inquiry.'
    }
  },
  partners: {
    title: {
      de: 'Partner & Sponsoren | Yetkin Dienstleistungen',
      en: 'Partners & Sponsors | Yetkin Dienstleistungen'
    },
    description: {
      de: 'Unsere Partner: Revo Hospitality, Louvre Hotels, Motel One, H-Hotels, Titanic Hotels, Leonardo Hotels, Ibis und mehr. Alba Berlin Sponsor.',
      en: 'Our partners: Revo Hospitality, Louvre Hotels, Motel One, H-Hotels, Titanic Hotels, Leonardo Hotels, Ibis and more. Alba Berlin sponsor.'
    }
  },
  careers: {
    title: {
      de: 'Karriere | Jobs bei Yetkin Dienstleistungen',
      en: 'Careers | Jobs at Yetkin Dienstleistungen'
    },
    description: {
      de: 'Werden Sie Teil des Yetkin-Teams! Wir suchen motivierte Mitarbeiter für Housekeeping, Front Office und mehr. Karrierechancen in der Hospitality-Branche.',
      en: 'Join the Yetkin team! We are looking for motivated employees for housekeeping, front office and more. Career opportunities in the hospitality industry.'
    }
  },
  news: {
    title: {
      de: 'Nachricht | Yetkin Dienstleistungen',
      en: 'News | Yetkin Dienstleistungen'
    },
    description: {
      de: 'Aktuelle Nachrichten und Neuigkeiten von Yetkin Dienstleistungen. Bleiben Sie informiert über unsere Hospitality-Services.',
      en: 'Latest news and updates from Yetkin Dienstleistungen. Stay informed about our hospitality services.'
    }
  },
  impressum: {
    title: {
      de: 'Impressum | Yetkin Dienstleistungen',
      en: 'Legal Notice | Yetkin Dienstleistungen'
    },
    description: {
      de: 'Impressum und rechtliche Informationen von Yetkin Dienstleistungen, Berlin.',
      en: 'Legal notice and information from Yetkin Dienstleistungen, Berlin.'
    }
  },
  datenschutz: {
    title: {
      de: 'Datenschutzerklärung | Yetkin Dienstleistungen',
      en: 'Privacy Policy | Yetkin Dienstleistungen'
    },
    description: {
      de: 'Datenschutzerklärung von Yetkin Dienstleistungen gemäß DSGVO. Informationen zur Verarbeitung Ihrer personenbezogenen Daten.',
      en: 'Privacy policy of Yetkin Dienstleistungen according to GDPR. Information about the processing of your personal data.'
    }
  }
};
